import * as React from 'react'
import { SheetContext } from './context'

export function useIsContentScrollable() {
  const { contentElement } = React.use(SheetContext)
  const [isScrollable, setIsScrollable] = React.useState(true)

  React.useEffect(() => {
    const checkHeight = () => {
      const contentHeight = contentElement?.scrollHeight || 0
      const clientHeight = contentElement?.clientHeight || 0
      setIsScrollable(contentHeight > clientHeight)
    }

    const resizeObserver = new ResizeObserver(() => {
      checkHeight()
    })

    if (contentElement) {
      resizeObserver.observe(contentElement)
    }

    window.addEventListener('resize', checkHeight)

    return () => {
      window.removeEventListener('resize', checkHeight)

      if (contentElement) {
        resizeObserver.unobserve(contentElement)
      }
    }
  }, [contentElement])

  return isScrollable
}
